module.exports = __webpack_public_path__ + "img/LevaNow-Logo.99477bb7.png";